"use client";
import React, { useState, useEffect } from "react";
import CalculateEmi from "./CalculateEmi.component";
import { DOWN_PAYMENT_AMOUNT_LISTS } from "./constants";
import { calculateMontlyEMI } from "../../utils/helpers/calculateEmi";

const CalculateEmiContainer = () => {
  const [phoneNumber, setPhoneNumber] = useState("");
  const [downpaymentAmount, setDownpaymentAmount] = useState(40000);
  const [loanTenure, setLoanTenure] = useState(48);
  const [monthlyEmiAmount, setMonthlyEmiAmount] = useState();

  const [errors, setErrors] = useState({});

  const handlePhoneNumberChange = (e) => {
    setPhoneNumber(e.target.value);
  };

  const validateForm = () => {
    let err = {};
    if (!phoneNumber || phoneNumber?.length !== 10) {
      err.phoneNumber = "*Please enter a valid 10-digit phone number";
    } else {
      err = {};
    }
    setErrors(err);
    return Object.keys(err).length === 0 ? true : false;
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      console.log("test kiran --->", "checking ===>", phoneNumber);
    }
  };

  const handleDownpaymentAmountChange = (value) => {
    setDownpaymentAmount(parseInt(value));
  };

  const handleLoanTenureChange = (value) => {
    setLoanTenure(parseInt(value));
  };

  const handleCalculateEmiButtonClick = () => {
    setMonthlyEmiAmount(calculateMontlyEMI(downpaymentAmount, loanTenure));
  };

  useEffect(() => {
    handleCalculateEmiButtonClick();
  }, [downpaymentAmount, loanTenure]);

  const containerProps = {
    downPaymentAmountLists: DOWN_PAYMENT_AMOUNT_LISTS,
    phoneNumber,
    errors,
    monthlyEmiAmount,
    loanTenure,
    downpaymentAmount,
  };
  const containerMethods = {
    handlePhoneNumberChange,
    handleSubmit,
    handleDownpaymentAmountChange,
    handleLoanTenureChange,
  };
  return (
    <CalculateEmi
      containerProps={containerProps}
      containerMethods={containerMethods}
    />
  );
};

export default CalculateEmiContainer;
